exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label[data-v-5966858f]{margin-bottom:-15px\n}\n.date-container[data-v-5966858f]{margin-right:20px\n}\n.publication-container[data-v-5966858f]{display:flex;align-items:center;justify-content:space-between\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5966858f","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/DateInputTime.vue
// module id = 205
// module chunks = 0